var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAggregate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.875V16.25C0 16.9404 0.643591 17.5 1.4375 17.5V1.875C1.4375 1.52982 1.7593 1.25 2.15625 1.25H20.125C20.125 0.559644 19.4814 0 18.6875 0H2.15625C0.965386 0 0 0.839466 0 1.875Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03125 2.5C3.84039 2.5 2.875 3.33947 2.875 4.375V18.125C2.875 19.1605 3.84039 20 5.03125 20H13.7796C14.3514 20 14.8999 19.8025 15.3043 19.4508L22.3685 13.3081C22.7728 12.9564 23 12.4795 23 11.9822V4.375C23 3.33947 22.0346 2.5 20.8438 2.5H5.03125ZM13.6562 13.125C13.6562 12.4346 14.2998 11.875 15.0938 11.875H21.4136C21.7338 11.875 21.8942 12.2116 21.6678 12.4085L14.2697 18.8415C14.0433 19.0384 13.6562 18.899 13.6562 18.6206V13.125Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAggregate);
export default __webpack_public_path__ + "static/media/ico-aggregate.f351919753e69fcda39399288b998d3a.svg";
export { ForwardRef as ReactComponent };